export default 'img';
